import { PagesizeType } from '../../service/pagination/pagesize-type';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Page } from '../../../shared/models/page';
import { isNullOrUndefined } from 'util';
import { DateUtil } from '../../../shared/utils/date.util';
import { PioneerValidators } from '../../../shared/utils/pioneer.validators';
import { OnyxEvent } from '../../models/event';
import { TransientReservation } from '../../models/reservation';
import { Rsvp } from '../../models/rsvp';
import { TransientReservationSearchParameters } from '../../models/transient-reservation-search-params';
import { TransientReservationStore } from '../../service/transient-reservation-store';
import { Constants } from '../../../shared/constants';
import { UserLocalStorageService } from '../../../permission/services/user.local.storage.service';
import { EventUtils } from 'app/event/utils/event-utils';
import { AuthenticationStore } from 'app/permission/services/authentication.store';

@Component({
  selector: 'pioneer-transient-search',
  templateUrl: './transient-search.component.html'
})
export class TransientSearchComponent implements OnInit {

  private _event: OnyxEvent;

  get event() {
    return this._event;
  }

  @Input()
  set event(event: OnyxEvent) {
    this._event = event;
    if (event) {
      if (this.currentEventId && (this.currentEventId !== event.eventId)) {
        this.resetForm();
      }
      this.currentEventId = event.eventId;
    }
  }

  public currentEventId: number;

  public transientSearchForm: FormGroup;

  public transientReservationSearch: TransientReservationSearchParameters;

  public checkInDates: any[];
  public checkOutDates: any[];

  @Output()
  public hasSearched: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  searchResults: Page<TransientReservation>;

  private _validateNameFilters = true;
  @Input()
  set validateNameFilters(validateNameFilters: boolean) { this._validateNameFilters = validateNameFilters; }

  @Output()
  searchClicked: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  isRatePlanCodeFilterVisible = false;

  @Input()
  isConfirmationFilterVisible = false;

  constructor(private formBuilder: FormBuilder,
              private transientReservationStore: TransientReservationStore,
              private userLocalStorageService: UserLocalStorageService,
              private authenticationStore: AuthenticationStore) { }

  ngOnInit() {
    if (!this.event) {
      throw new Error('The "event" attribute must be specified to use the TransientSearchComponent component');
    }
    this.initSearchForm(null);
  }

  resetForm() {
    this.initSearchForm(null);
    this.transientReservationStore.setTransientReservationPage(new Page<TransientReservation>());
    this.hasSearched.emit(false);
  }

  initSearchForm(rsvp: Rsvp) {

    const _startDate = EventUtils.getEventStartDate(this.event, this.authenticationStore.isAgencyUser());
    const _endDate = EventUtils.getEventEndDate(this.event, this.authenticationStore.isAgencyUser());

    // Calculate 3 days prior to the event start date
    this.checkInDates = [
      _startDate,
      DateUtil.subtractDaysFromDate(_startDate, 1),
      DateUtil.subtractDaysFromDate(_startDate, 2),
      DateUtil.subtractDaysFromDate(_startDate, 3)
    ];

    // Calculate 3 days after the event end date
    this.checkOutDates = [
      _endDate,
      DateUtil.addDaysToDate(_endDate, 1),
      DateUtil.addDaysToDate(_endDate, 2),
      DateUtil.addDaysToDate(_endDate, 3)
    ];

    this.transientSearchForm = this.formBuilder.group({
        firstName: [rsvp ? rsvp.firstName : null,
          [Validators.maxLength(50)]],
        lastName: [rsvp ? rsvp.lastName : null,
          [Validators.maxLength(50)]],
        minCheckInDate: [_startDate, [PioneerValidators.isDate]],
        maxCheckOutDate: [_endDate, [PioneerValidators.isDate]],
        ratePlanCode: [null, [Validators.maxLength(10)]],
        confirmation: [null, [Validators.maxLength(32)]]
      }, {
        validator: this._validateNameFilters ? PioneerValidators.isFirstNameOrLastNameRequiredCrossValidator('firstName', 'lastName') : null
      }
    );

  }

  searchTransientReservations(event: any): void {
    event.preventDefault();
    this.refreshTransientReservations(Constants.SEARCH_DEFAULT_PAGE);
    this.searchClicked.emit();
  }

  refreshTransientReservations(page: number, searchParams?: TransientReservationSearchParameters): void {

    if (searchParams) {
      this.transientReservationSearch = searchParams;
    } else {
      this.transientReservationSearch = new TransientReservationSearchParameters({
        eventId: this.event.eventId,
        eventPartyId: this.event.eventProperty.eventPartyId,
        firstName: this.parseString(this.transientSearchForm.get('firstName').value),
        lastName: this.parseString(this.transientSearchForm.get('lastName').value),
        minCheckInDate: DateUtil.formatDate(this.transientSearchForm.get('minCheckInDate').value),
        maxCheckOutDate: DateUtil.formatDate(this.transientSearchForm.get('maxCheckOutDate').value),
        ratePlanCode: this.parseString(this.transientSearchForm.get('ratePlanCode').value),
        confirmation: this.parseString(this.transientSearchForm.get('confirmation').value)
      });
    }

    this.transientReservationStore.searchTransientReservations(this.transientReservationSearch, page,
      this.userLocalStorageService.getPagesize(PagesizeType.TRANSIENT_RESERVATIONS)).subscribe(
      result => {
        this.hasSearched.emit(true);
      }
    );
  }

  private parseString(value: string): string {
    if (isNullOrUndefined(value) || value.trim().length === 0) {
      return null;
    }
    return value;
  }

  public disableSearch(): boolean {
    let disable: boolean;
    if (this.transientSearchForm) {
      disable = !this.transientSearchForm.valid;
    } else {
      disable = true;
    }
    return disable;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-search/transient-search.component.ts